module.exports = remoteOneStyle;